{
  "title": "Кошелёк",
  "subtitle": "Баланс читается только с сервера. Реальные операции ещё не включены.",
  "real": "Основной баланс",
  "bonus": "Бонус",
  "reserved": "Резерв",
  "unavailable": "Данные баланса недоступны",
  "deposit": "Депозит",
  "withdraw": "Вывод",
  "history": "История",
  "comingSoon": "Платёжные сценарии скоро"
}
